import { useTranslation } from 'react-i18next';
import { BUILD_ID } from '@lib/buildInfo';

/**
 * Tiny, unobtrusive build-version stamp. Shown in the login page, the sidebar
 * footer, and the supervisor portal so operators can always confirm they are on
 * the latest deployed bundle (a stale/cached build shows an old commit here).
 *
 * `full` shows "commit · date"; otherwise just the commit hash. The value is
 * always LTR (it's a hash + timestamp) even inside an RTL layout.
 */
export default function BuildStamp({
  className = '',
  full = false,
}: {
  className?: string;
  full?: boolean;
}) {
  const { i18n } = useTranslation();
  const isRtl = i18n.dir() === 'rtl';
  const label = isRtl ? 'نسخة' : 'build';
  return (
    <span
      dir="ltr"
      title={isRtl ? `نسخة البناء: ${BUILD_ID}` : `Build version: ${BUILD_ID}`}
      className={`inline-flex items-center gap-1 font-mono text-[10.5px] leading-none text-fg-subtle/70 select-all ${className}`}
    >
      <span aria-hidden className="opacity-60">{label}</span>
      <span>{full ? BUILD_ID : BUILD_ID.split(' · ')[0]}</span>
    </span>
  );
}
